import React from "react";
import classes from "./link.module.css";
import { NavLink } from "react-router-dom";

const Link = ({ children, href, extraClass }) => {
  return (
    <NavLink to={href} className={[classes.link, extraClass].join(" ")}>
      {children}
    </NavLink>
  );
};
export default Link;
